// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

import { CartProvider } from './context/CartContext';

// Layouts
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import AdminLayout from './admin/AdminLayout';

// Pages publiques
import Accueil from './pages/Accueil';
import About from './pages/About';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Register from './pages/Register';
import ProductDetail from './pages/ProductDetail';
import CategoryPage from './pages/CategoryPage';
import Boutique from './pages/Boutique';
import CartPage from './pages/CartPage';
import NotificationsPage from './pages/NotificationsPage';
import ProfilePage from './pages/ProfilePage';
import GuideTailles from './pages/GuideTailles';
import FAQ from './pages/FAQ';
import LivraisonEchanges from './pages/LivraisonEchanges';
import NotreHistoire from './pages/NotreHistoire';
import SuiviCommande from './pages/SuiviCommande';
import MentionsLegales from './pages/MentionsLegales';
import CGV from './pages/CGV';
import Confidentialite from './pages/Confidentialite';
import NotFound from './pages/NotFound';
import SearchResults from './pages/SearchResults';

// Pages admin
import AdminDashboard from './admin/Dashboard';
import AdminProducts from './admin/AdminProducts';
import AdminProductForm from './admin/AdminProductForm';
import AdminProductVariants from './admin/AdminProductVariants';
import AdminCategories from './admin/AdminCategories';
import AdminOrders from './admin/AdminOrders';
import AdminOrderDetail from './admin/AdminOrderDetail';
import AdminClients from './admin/AdminClients';
import AdminContacts from './admin/AdminContacts';
import AdminReviews from './admin/AdminReviews';
import AdminPromotions from './admin/AdminPromotions';
import AdminOffers from './admin/AdminOffers';
import AdminShipping from './admin/AdminShipping';
// Styles
import './styles/madad-tokens.css';
import './styles/madad-components.css';
import './styles/madad-admin.css';
import ScrollToTop from './components/common/ScrollToTop';

/* =========================================================
   LAYOUT PUBLIC
========================================================= */
function Layout({ user, onLogout }) {
  return (
    <>
      <Header user={user} onLogout={onLogout} />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function App() {
  const [user, setUser] = React.useState(null);

  const handleLogin  = (userData) => setUser(userData);
  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('user_data');
    setUser(null);
  };

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <ScrollToTop />
        <CartProvider>
          <Routes>

            {/* ============ ADMIN ============ */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />

              {/* Produits */}
              <Route path="produits"                  element={<AdminProducts />} />
              <Route path="produits/nouveau"          element={<AdminProductForm />} />
              <Route path="produits/:id"              element={<AdminProductForm />} />
              <Route path="produits/:id/variantes"    element={<AdminProductVariants />} />

              {/* Autres */}
              <Route path="categories"   element={<AdminCategories />} />
              <Route path="commandes"    element={<AdminOrders />} />
              <Route path="commandes/:id" element={<AdminOrderDetail />} />
              <Route path="clients"      element={<AdminClients />} />
              <Route path="contacts"     element={<AdminContacts />} />
              <Route path="avis"         element={<AdminReviews />} />
              <Route path="offres" element={<AdminOffers />} />
              <Route path="livraison" element={<AdminShipping />} />
              <Route path="promotions"   element={<AdminPromotions />} />
            </Route>

            {/* ============ SITE PUBLIC ============ */}
            <Route path="/" element={<Layout user={user} onLogout={handleLogout} />}>
              <Route index element={<Accueil />} />
              <Route path="about" element={<About />} />
              <Route path="contact" element={<Contact />} />
              <Route path="boutique" element={<Boutique />} />
              <Route path="cart" element={<CartPage />} />
              <Route path="product/:id" element={<ProductDetail />} />
              <Route path="notifications" element={<NotificationsPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="guide-des-tailles" element={<GuideTailles />} />
              <Route path="faq" element={<FAQ />} />
              <Route path="livraison-echanges" element={<LivraisonEchanges />} />
              <Route path="notre-histoire" element={<NotreHistoire />} />
              <Route path="suivi-commande" element={<SuiviCommande />} />
              <Route path="mentions-legales" element={<MentionsLegales />} />
              <Route path="cgv" element={<CGV />} />
              <Route path="confidentialite" element={<Confidentialite />} />
              <Route path="search" element={<SearchResults />} />
              {/* Catégorie dynamique — DOIT ÊTRE EN DERNIER */}
              <Route path=":categorie" element={<CategoryPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            {/* ============ AUTH (sans layout) ============ */}
            <Route path="/login"    element={<Login onLogin={handleLogin} />} />
            <Route path="/register" element={<Register />} />

          </Routes>
        </CartProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;